import componentGlobalSaver from '../utils/componentGlobalSaver'

const asyncDataHelper = {
  /**
   * after router has resolved all async before hooks
   * called that function
   * @param c {Vue}
   * @param store {Vuex}
   * @param from {Object}
   * @param to {Object}
   * @returns {Promise<number>}
   */
  handleAsyncData (c, {store, from, to}) {
    let methods = Object.create(null) // c.methods
    if (c.mixins) {
      c.mixins.forEach((mixin) => {
        // TODO: go deepy get from mixin.mixins.forEach...
        if (mixin.methods) {
          for (let name in mixin.methods) {
            methods[name] = mixin.methods[name]
          }
        }
      })
    }
    if (c.methods) {
      for (let name in c.methods) {
        methods[name] = c.methods[name]
      }
    }
    if (c.asyncData) {
      return c.asyncData({store, route: to, fromRoute: from, methods, ctx: c})
    } else if (c.mixins) {
      let last = null
      c.mixins.forEach((mixin) => {
        if (mixin.asyncData) {
          last = mixin.asyncData({store, route: to, fromRoute: from, methods, ctx: c})
        }
      })
      if (last !== null) {
        return last
      }
    }
    return Promise.resolve(1)
  },
  /**
   * Find async data in GlobalComponent or GlobalComponent mixin and call
   * @param componentName
   * @param asyncDataOptions
   * @returns {Promise<number>}
   */
  execAsyncDataInGlobalComponent (componentName, asyncDataOptions) {
    let component = componentGlobalSaver.restore(componentName)
    if (component) {
      asyncDataOptions.ctx = {
        components: {
          [componentName]: component
        }
      }
      return this.execAsyncDataInChild(asyncDataOptions)
    }
    return Promise.resolve(1)
  },
  /**
   * Find async data in child or child mixin and call
   * @param store
   * @param route
   * @param fromRoute
   * @param methods
   * @param ctx
   * @returns {Promise<number>}
   */
  execAsyncDataInChild ({store, route, fromRoute, methods, ctx}) {
    // console.log('---', methods, ctx)
    if (ctx && ctx.components) {
      let foundedAsyncData = null
      let methods = methods
      // search first
      for (let componentName in ctx.components) {
        let component = ctx.components[componentName]
        if (foundedAsyncData === null) {
          // im component
          if (component.asyncData) {
            foundedAsyncData = component.asyncData
            methods = component.methods
          } else if (component.mixins) {
          // or in first mixin
            for (let i = 0; i < component.mixins.length; i++) {
              if (component.mixins[i].asyncData) {
                foundedAsyncData = component.mixins[i].asyncData
                methods = component.methods
                break
              }
            }
          }
        }
      }
      if (foundedAsyncData) {
        // console.log('----', foundedAsyncData)
        return foundedAsyncData({store, route, fromRoute, methods, ctx})
      }
    }
    return Promise.resolve(1)
  }
}

export default asyncDataHelper
